define('services/fileSizeFormatterService',['../lib/knockout'], function (ko) {
    'use strict';

    var FileSizeFormatter = function () {
        var self = this;

        var fileUnitStrings = [
            'units.bytes',
            'units.kilobytes',
            'units.megabytes',
            'units.gigabytes',
            'units.terabytes'
        ];

        function getFileUnits(index) {
            return ko.i18n.renderString(fileUnitStrings[index]);
        }

        function localizeSizeFormat(size, units) {
            return ko.i18n.renderString('formats.size', {size: size, units: units});
        }

        /**
         * Formats bytes into a more readable string
         *  Ex: 1024 -> 1 KB, 1048576 -> 1 MB, etc
         * @param sizeBytes
         * @param digits - number of digits to appear after the decimal point.  This value may be between 0 and 20 inclusive.  If
         * the argument is omitted it defaults to 0
         * @returns {*}
         */
        self.formatBytes = function (sizeBytes, digits) {
            var bytes = ko.utils.unwrapObservable(sizeBytes);

            if (bytes === 0) {
                return localizeSizeFormat(0, getFileUnits(0));
            }
            var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), null);

            if (i === 0) {
                return localizeSizeFormat(bytes, getFileUnits(i));
            }

            return localizeSizeFormat((bytes / Math.pow(1024, i)).toFixed(digits), getFileUnits(i));
        };
    };

    return new FileSizeFormatter();
});
